'use strict';
module.exports = require('../../full/array/for-each');
